import 'core-js/stable';
import 'regenerator-runtime/runtime';

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
